import { useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return toast.error("Password must be at least 6 characters");
    if (pw !== pw2) return toast.error("Passwords don't match");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated. Please log in.");
      navigate("/login");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="reset-password-page">
      <div className="max-w-md w-full border border-[rgba(10,10,10,0.10)] bg-[#FAF5E6] p-10">
        <div className="font-mono uppercase tracking-[0.25em] text-xs text-[#525252]">Choose new password</div>
        <h1 className="font-heading text-4xl text-[#0A0A0A] mt-3">Set a new one.</h1>
        {!token ? (
          <p className="mt-6 text-sm text-[#7C1D1D]">This reset link is missing its token. Request a new one from the <Link to="/forgot-password" className="underline">forgot password</Link> page.</p>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <label className="font-mono uppercase tracking-widest text-[10px] text-[#525252]">New password</label>
              <input
                type="password" required minLength={6}
                value={pw} onChange={(e) => setPw(e.target.value)}
                className="w-full mt-1 bg-white border border-[rgba(10,10,10,0.12)] rounded-sm px-3 py-2.5 text-sm focus:outline-none focus:ring-1 focus:ring-black"
                data-testid="reset-pw1"
              />
            </div>
            <div>
              <label className="font-mono uppercase tracking-widest text-[10px] text-[#525252]">Confirm</label>
              <input
                type="password" required minLength={6}
                value={pw2} onChange={(e) => setPw2(e.target.value)}
                className="w-full mt-1 bg-white border border-[rgba(10,10,10,0.12)] rounded-sm px-3 py-2.5 text-sm focus:outline-none focus:ring-1 focus:ring-black"
                data-testid="reset-pw2"
              />
            </div>
            <button
              type="submit"
              disabled={busy || !pw || !pw2}
              className="w-full inline-flex items-center justify-center gap-2 bg-[#0A0A0A] hover:bg-[#1F1F1F] text-[#F2EAD3] font-mono uppercase tracking-widest text-xs px-4 py-3 rounded-sm transition-colors disabled:opacity-50"
              data-testid="reset-submit"
            >
              {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : "Update password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
